export const DEFAULT_VEHICLE_IMAGE =
  'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta5ac237e4e8755fe/62df4c64df0a3871e08a41c8/lcv-compare-default.jpg';
